import { Box, Drawer, IconButton, Typography } from '@mui/material';
import { MdClose } from 'react-icons/md';
import { useGetHelpCenterArticle } from 'apis/agency/integrations/hook';
import HelpArticleContent from 'components/Common/HelpArticleContent';
import HelpArticleSkeleton from './HelpArticleContent/HelpArticleSkeleton';

interface DocumentationDrawerProps {
  open: boolean;
  onClose: () => void;
  articleId: string | number | null;
  fallbackTitle?: string;
}

export default function DocumentationDrawer({
  open,
  onClose,
  articleId,
  fallbackTitle = 'Documentation'
}: DocumentationDrawerProps) {
  const {
    data: helpArticleData,
    isLoading: docsLoading,
    isError: docsError
  } = useGetHelpCenterArticle(articleId, {
    enabled: open && !!articleId
  });

  return (
    <Drawer
      anchor='right'
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: '50%',
          maxWidth: '90vw'
        }
      }}
    >
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ px: 3, py: 2, borderBottom: 1, borderColor: 'divider' }}>
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <Typography variant='h6' fontWeight={600}>
              {helpArticleData?.title ?? fallbackTitle}
            </Typography>
            <IconButton onClick={onClose} aria-label='Close documentation'>
              <MdClose />
            </IconButton>
          </Box>
        </Box>
        <Box sx={{ flexGrow: 1, overflow: 'auto', px: 3 }}>
          {!articleId && open ? (
            <Typography variant='body2' color='text.secondary'>
              Documentation is not linked for this item yet.
            </Typography>
          ) : docsLoading ? (
            <Box display='flex' justifyContent='center' alignItems='center' minHeight={200}>
              <HelpArticleSkeleton />
            </Box>
          ) : docsError ? (
            <Typography variant='body2' color='error'>
              Unable to load documentation. Please try again later.
            </Typography>
          ) : (
            <Box border='1px solid #ECECEC' paddingX={2} my={2} borderRadius={1}>
              <HelpArticleContent html={helpArticleData?.body ?? ''} />
            </Box>
          )}
        </Box>
      </Box>
    </Drawer>
  );
}
